/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'getSystemTranslations',
    message: messages.SUCCESS_GET_SYSTEM_TRANSLATIONS,
    method: 'GET',
    path: '/system/:systemId/translations',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_SYSTEM_TRANSLATION,
    requestSchema: requestSchemas.systemTranslations.getSystemTranslations,
    scopes: [
      scopes.DEFAULT,
      scopes.SYSTEM_TRANSLATIONS_GLOBAL,
      scopes.SYSTEM_TRANSLATIONS_INPUT,
    ],
  },
  {
    action: 'updateSystemTranslations',
    message: messages.SUCCESS_UPDATE_SYSTEM_TRANSLATIONS,
    method: 'PATCH',
    path: '/system/:systemId/translations',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.UPDATE_SYSTEM_TRANSLATION,
    requestSchema: requestSchemas.systemTranslations.updateSystemTranslations,
  },
];
